function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import mb2css from 'mapbox-to-css-font';
import { checkedFonts } from 'ol/render/canvas.js';
import { createCanvas } from './util.js';
var hairSpacePool = Array(256).join("\u200A");
export function applyLetterSpacing(text, letterSpacing) {
  if (letterSpacing >= 0.05) {
    var textWithLetterSpacing = '';
    var lines = text.split('\n');
    var joinSpaceString = hairSpacePool.slice(0, Math.round(letterSpacing / 0.1));
    for (var l = 0, ll = lines.length; l < ll; ++l) {
      if (l > 0) {
        textWithLetterSpacing += '\n';
      }
      textWithLetterSpacing += lines[l].split('').join(joinSpaceString);
    }
    return textWithLetterSpacing;
  }
  return text;
}
var measureContext;
function getMeasureContext() {
  if (!measureContext) {
    measureContext = createCanvas(1, 1).getContext('2d');
  }
  return measureContext;
}
function measureText(text, letterSpacing) {
  return getMeasureContext().measureText(text).width + (text.length - 1) * letterSpacing;
}
var measureCache = {};
checkedFonts.on('propertychange', function () {
  for (var key in measureCache) {
    delete measureCache[key];
  }
});
export function wrapText(text, font, em, letterSpacing) {
  if (text.indexOf('\n') !== -1) {
    var hardLines = text.split('\n');
    var lines = [];
    for (var i = 0, ii = hardLines.length; i < ii; ++i) {
      lines.push(wrapText(hardLines[i], font, em, letterSpacing));
    }
    return lines.join('\n');
  }
  var key = em + ',' + font + ',' + text + ',' + letterSpacing;
  var wrappedText = measureCache[key];
  if (!wrappedText) {
    var words = text.split(' ');
    if (words.length > 1) {
      var ctx = getMeasureContext();
      ctx.font = font;
      var oneEm = ctx.measureText('M').width;
      var maxWidth = oneEm * em;
      var line = '';
      var _lines = [];
      // Pass 1 - wrap lines to not exceed maxWidth
      for (var _i = 0, _ii = words.length; _i < _ii; ++_i) {
        var word = words[_i];
        var testLine = line + (line ? ' ' : '') + word;
        if (measureText(testLine, letterSpacing) <= maxWidth) {
          line = testLine;
        } else {
          if (line) {
            _lines.push(line);
          }
          line = word;
        }
      }
      if (line) {
        _lines.push(line);
      }
      // Pass 2 - add lines with a width of less than 30% of maxWidth to the previous or next line
      for (var _i2 = 0, _ii2 = _lines.length; _i2 < _ii2 && _ii2 > 1; ++_i2) {
        var _line = _lines[_i2];
        if (measureText(_line, letterSpacing) < maxWidth * 0.35) {
          var prevWidth = _i2 > 0 ? measureText(_lines[_i2 - 1], letterSpacing) : Infinity;
          var nextWidth = _i2 < _ii2 - 1 ? measureText(_lines[_i2 + 1], letterSpacing) : Infinity;
          _lines.splice(_i2, 1);
          _ii2 -= 1;
          if (prevWidth < nextWidth) {
            _lines[_i2 - 1] += ' ' + _line;
            _i2 -= 1;
          } else {
            _lines[_i2] = _line + ' ' + _lines[_i2];
          }
        }
      }
      // Pass 3 - try to fill 80% of maxWidth for each line
      for (var _i3 = 0, _ii3 = _lines.length - 1; _i3 < _ii3; ++_i3) {
        var _line2 = _lines[_i3];
        var next = _lines[_i3 + 1];
        if (measureText(_line2, letterSpacing) > maxWidth * 0.7 && measureText(next, letterSpacing) < maxWidth * 0.6) {
          var lineWords = _line2.split(' ');
          var lastWord = lineWords.pop();
          if (measureText(lastWord, letterSpacing) < maxWidth * 0.2) {
            _lines[_i3] = lineWords.join(' ');
            _lines[_i3 + 1] = lastWord + ' ' + next;
          }
          _ii3 -= 1;
        }
      }
      wrappedText = _lines.join('\n');
    } else {
      wrappedText = text;
    }
    wrappedText = applyLetterSpacing(wrappedText, letterSpacing);
    measureCache[key] = wrappedText;
  }
  return wrappedText;
}
var webSafeFonts = ['Arial', 'Courier New', 'Times New Roman', 'Verdana', 'sans-serif', 'serif', 'monospace', 'cursive', 'fantasy'];
var processedFontFamilies = {};

/**
 * @param {Array} fonts Fonts.
 * @param {string} [templateUrl] Template URL.
 * @return {Array} Processed fonts.
 * @private
 */
export function getFonts(fonts) {
  var templateUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://cdn.jsdelivr.net/npm/@fontsource/{font-family}/{fontweight}{-fontstyle}.css';
  var fontDescriptions;
  for (var i = 0, ii = fonts.length; i < ii; ++i) {
    var font = fonts[i];
    if (font in processedFontFamilies) {
      continue;
    }
    processedFontFamilies[font] = true;
    var cssFont = mb2css(font, 16);
    var parts = cssFont.split(' ');
    if (!fontDescriptions) {
      fontDescriptions = [];
    }
    fontDescriptions.push([parts.slice(3).join(' ').replace(/"/g, ''), parts[1], parts[0]]);
  }
  if (!fontDescriptions) {
    return fonts;
  }
  _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _loop, _i4, _ii4;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return document.fonts.ready;
        case 1:
          _loop = /*#__PURE__*/_regenerator().m(function _loop() {
            var fontDescription, family, weight, style, loaded, fontUrl, markup;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  fontDescription = fontDescriptions[_i4];
                  family = fontDescription[0];
                  if (!webSafeFonts.includes(family)) {
                    _context.n = 1;
                    break;
                  }
                  return _context.a(2, 1);
                case 1:
                  weight = fontDescription[1];
                  style = fontDescription[2];
                  _context.n = 2;
                  return document.fonts.load("".concat(style, " ").concat(weight, " 16px \"").concat(family, "\""));
                case 2:
                  loaded = _context.v;
                  if (!loaded.some(function (f) {
                    return f.family.replace(/^['"]|['"]$/g, '').toLowerCase() === family.toLowerCase() && f.weight == weight && f.style === style;
                  })) {
                    fontUrl = templateUrl.replace('{font-family}', family.replace(/ /g, '-').toLowerCase()).replace('{Font+Family}', family.replace(/ /g, '+')).replace('{fontweight}', weight).replace('{-fontstyle}', style.replace('normal', '').replace(/(.+)/, '-$1')).replace('{fontstyle}', style);
                    if (!document.querySelector('link[href="' + fontUrl + '"]')) {
                      markup = document.createElement('link');
                      markup.href = fontUrl;
                      markup.rel = 'stylesheet';
                      document.head.appendChild(markup);
                    }
                  }
                case 3:
                  return _context.a(2);
              }
            }, _loop);
          });
          _i4 = 0, _ii4 = fontDescriptions.length;
        case 2:
          if (!(_i4 < _ii4)) {
            _context2.n = 5;
            break;
          }
          return _context2.d(_regeneratorValues(_loop()), 3);
        case 3:
          if (!_context2.v) {
            _context2.n = 4;
            break;
          }
          return _context2.a(3, 4);
        case 4:
          ++_i4;
          _context2.n = 2;
          break;
        case 5:
          return _context2.a(2);
      }
    }, _callee);
  }))();
  return fonts;
}